import { RowSelectionContext } from "@/components/data-table/context/RowSelectionContext";
import { RowSelectionState } from "@tanstack/react-table";
import { useContext, useMemo, useSyncExternalStore } from "react";

const EMPTY_SELECTED_IDS: ReadonlySet<string> = new Set<string>();
const noopSubscribe = () => () => undefined;

export const useSelectedRowIds = ({
  rowSelection,
}: {
  rowSelection?: RowSelectionState;
}) => {
  const selectionStore = useContext(RowSelectionContext)?.store;

  const selectionRevision = useSyncExternalStore(
    selectionStore?.subscribe ?? noopSubscribe,
    () => selectionStore?.getRevision() ?? 0,
    () => 0,
  );

  return useMemo(() => {
    if (rowSelection !== undefined) {
      return new Set(
        Object.entries(rowSelection)
          .filter(([, isSelected]) => Boolean(isSelected))
          .map(([id]) => String(id)),
      );
    }
    if (!selectionStore || selectionRevision < 0) {
      return EMPTY_SELECTED_IDS;
    }
    return new Set(selectionStore.getSelection());
  }, [rowSelection, selectionStore, selectionRevision]);
};
